import { Box } from '../../Box';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { idBuilder } from '../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
const resolveWidth = width => {
  if (!width) {
    return 'auto';
  }
  return typeof width === 'string' ? width : `${width}px`;
};
const style = (theme, width) => {
  const effectiveMinWidth = width && typeof width === 'string' ? width : `${width || 240}px`;
  return {
    display: 'flex',
    flexDirection: 'column',
    width: resolveWidth(width),
    minWidth: effectiveMinWidth,
    borderRadius: '4px',
    backgroundColor: theme.tokens.SemColorSurfaceDefault,
    border: `1px solid ${theme.tokens.SemColorBorderMuted}`,
    boxShadow: theme.tokens.BaseShadowMd
  };
};
export const MenuContainer = props => {
  const {
    id,
    width,
    children,
    ...rest
  } = props;
  const theme = useInterstateTheme();
  return /*#__PURE__*/_jsx(Box, {
    className: 'ids-menu-container',
    id: idBuilder('ids-menu-container', id),
    "data-testid": idBuilder('ids-menu-container', rest['data-testid']),
    sx: style(theme, width),
    children: children
  });
};